import * as React from 'react'
import classNames from 'classnames'

import type { Image } from 'types'
import HeadlineThree from '../../00-Primitives/Headlines/HeadlineThree'
import Paragraph from 'content-components/_Primatives/Paragraph'
import { InlineImage } from 'content-components/_Primatives/Images'

import style from './style.scss'

export type Props = {
  bodyText?: string
  className?: string
  gradient?: boolean
  headlineText: string
  image: Image
  imageSizes?: string
}

PromoCard.defaultProps = {
  gradient: false,
  imageSizes: undefined,
  bodyText: '',
}

function PromoCard(props: Props) {
  const {
    className,
    gradient,
    image,
    imageSizes,
    headlineText,
    bodyText,
  } = props

  return (
    <div className={classNames(style.wrapper, className)}>
      <InlineImage
        className={style.image}
        gradient={gradient}
        image={image}
        sizes={imageSizes}
      />
      <div className={style.cardContent}>
        <HeadlineThree className={style.title}>{headlineText}</HeadlineThree>
        <Paragraph className={style.body}>{bodyText}</Paragraph>
      </div>
    </div>
  )
}

export default PromoCard
